import React from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, Row, Col } from "reactstrap"

const Miniwidget = props => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Row>
        {props.user?.userType === "Admin" &&
          props.reports.map((report, key) => (
            <Col xl={3} sm={6} key={key} onClick={() => navigate(`${report.navigateLink}`)} style={{ cursor: "pointer" }}>
              <Card className="mini-stat bg-primary">
                <CardBody className="card-body mini-stat-img">
                  <div className="mini-stat-icon">
                    <i className={"float-end mdi mdi-" + report.iconClass}></i>
                  </div>
                  <div className="text-white">
                    <h6 className="text-uppercase mb-3 font-size-16 text-white">{report.title}</h6>
                    <h2 className="mb-4 text-white">{report.total}</h2>
                    <span className={"badge bg-" + report.badgecolor}> {report.average} </span> <span className="ms-2">From previous period</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}

        {props.user?.userType === "Trainer" &&
          props.trainerReports.map((report, key) => (
            <Col xl={3} sm={6} key={key} onClick={() => navigate(`${report.navigateLink}`)} style={{ cursor: "pointer" }}>
              <Card className="mini-stat bg-primary">
                <CardBody className="card-body mini-stat-img">
                  <div className="mini-stat-icon">
                    <i className={"float-end mdi mdi-" + report.iconClass}></i>
                  </div>
                  <div className="text-white">
                    <h6 className="text-uppercase mb-3 font-size-16 text-white">{report.title}</h6>
                    <h2 className="mb-4 text-white">{report.total}</h2>
                    <span className={"badge bg-" + report.badgecolor}> {report.average} </span> <span className="ms-2">From previous period</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
      </Row>
    </React.Fragment>
  )

}

export default Miniwidget
